'use client'

import type { Dispatch, SetStateAction } from 'react'
import { Loader2 } from 'lucide-react'
import type { ProcessedTheme } from '../ProcessedEntry/DomainEntry/processedTypes'
import { watchClasses } from '../ProcessedEntry/DomainEntry/processedTypes'
import { ScamClassificationForm } from './ScamClassificationForm'
import type { ScamData } from './entryTypes'

// Wraps the existing ScamClassificationForm (is_scam + claims/value/
// translation — already generic, used as-is) with a Save action, same
// "Classificação" capability Old Cases offers (CasosView's
// handleSaveClassification/`/classification` endpoint). Its own widget so
// any case-management page gets the save button next to the form instead of
// wiring that POST call inline every time.
export function ClassificationWidget({
  theme,
  scamData,
  setScamData,
  onSave,
  saving,
}: {
  theme: ProcessedTheme
  scamData: ScamData
  setScamData: Dispatch<SetStateAction<ScamData>>
  onSave: () => void
  saving?: boolean
}) {
  const c = watchClasses(theme)
  return (
    <div>
      <ScamClassificationForm scamData={scamData} setScamData={setScamData} theme={theme} />
      <button
        type="button"
        onClick={onSave}
        disabled={saving}
        className="mt-2 flex items-center gap-1.5 rounded bg-primary text-primary-foreground px-3 py-1.5 text-[12px] font-semibold text-white transition-colors hover:bg-signal disabled:opacity-40"
      >
        {saving ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : null}
        Save Classification
      </button>
      <p className={`mt-1.5 text-[10px] ${c.faint}`}>
        Saving records a new pipeline step immediately. &ldquo;É burla?&rdquo; here also controls what Accept publishes.
      </p>
    </div>
  )
}
